import { Colors } from "../styles/constant";
import activAssureDiamondIcon from "../assets/icons/ActivAssureDiamondIcon.svg";
import activAssureDiamondIconRed from "../assets/icons/ActivAssureDiamondIcon-red.svg";
import activAssureDiamondPlusIcon from "../assets/icons/ActivAssureDiamondPlusIcon.svg";
import activAssureDiamondPlusIconRed from "../assets/icons/ActivAssureDiamondPlusIcon-red.svg";
import activFitPlusIcon from "../assets/icons/ActivFitPlusIcon.svg";
import activFitPlusIconRed from "../assets/icons/ActivFitPlusIcon-red.svg";
import activFitPreferredIcon from "../assets/icons/ActivFitPreferredIcon.svg";
import activFitPreferredIconRed from "../assets/icons/ActivFitPreferredIcon-red.svg";
import activHealthPlatinumEnhancedIcon from "../assets/icons/ActivHealthPlatinumEnhancedIcon.svg";
import activHealthPlatinumEnhancedIconRed from "../assets/icons/ActivHealthPlatinumEnhancedIcon-red.svg";
import activHealthPlatinumEssentialIcon from "../assets/icons/ActivHealthPlatinumEssentialIcon.svg";
import activHealthPlatinumEssentialIconRed from "../assets/icons/ActivHealthPlatinumEssentialIcon-red.svg";
import activOneMaxIcon from "../assets/icons/activonemax-gray.svg";
import activOneMaxIconRed from "../assets/icons/ActivOneMaxIcon-red.svg";
import activOneNxtIcon from "../assets/icons/activonenxt-gray.svg";
import activOneNxtIconRed from "../assets/icons/ActivOneNxtIcon-red.svg";
import superTopUpPlanBIcon from "../assets/icons/SuperTopUpPlanBIcon.svg";
import superTopUpPlanBIconRed from "../assets/icons/SuperTopUpPlanBIcon-red.svg";
import topUpPlanGenericIcon from "../assets/icons/TopUpPlanGenericIcon.svg";
import topUpPlanGenericIconRed from "../assets/icons/TopUpPlanGenericIcon-red.svg";
import BasePlanGenericIcon from "../assets/icons/BasePlanGenericIcon.svg";
import BasePlanGenericIconRed from "../assets/icons/BasePlanGenericIcon-red.svg";
import { T_InsuredDetail } from "../features/Feature_HealthInsurance/HealthInsurance_Types";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { isEmpty } from "lodash";
import {
  E_ChannelOptions,
  T_CsAppSliceState,
} from "../globalTypes/GlobalTypes";
import {
  Abcd_Super_App_Lob_Id,
  HiDestinationLobId,
  HomeLoansDestinationLobId,
  LiDestinationLobId,
  LoansDestinationLobId,
  MfDestinationLobId,
  motorInsuranceProductTypes,
  motorInsurerNames,
  OneLoginLobCode,
  platformMobile,
  platformSuperApp,
  platformWeb,
  SCREEN_TYPE,
  SsDestinationLobId,
  transactionApiStatus,
  transactionStatus,
  transactionTypes,
} from "./constants";
import TriggerGTAEvent from "./GTA";
import { triggerCleverTapEvent } from "./CleverTap";
import { ACTIONS } from "./CleverTapConstant";
import giftBoxIcon from "../assets/icons/abcd-gold-gift-icon.svg";
import alertCircleIcon from "../assets/icons/abcd-alert-circle-icon.svg";
import checkCircleIcon from "../assets/icons/abcd-check-circle-icon.svg";
import carInsuranceIcon from "../assets/icons/abcd-car-insurance-icon.svg";
import bikeInsuranceIcon from "../assets/icons/abcd-bike-insurance-icon.svg";
import iciciLombardInsurerLogo from "../assets/icons/abcd-iciciLombard-insurance-logo.svg";
import ackoInsurerLogo from "../assets/icons/abcd-acko-insurance-logo.svg";
import digitInsurerLogo from "../assets/icons/abcd-digit-insurance-logo.svg";
import amberClockIcon from "../assets/icons/abcd-clock-time-seven-icon.svg";
import { T_FetchPolicyDetails_Response } from "../features/Feature_LifeInsurance/LifeInsurance_Types";
import {
  T_Fetch_HomeLoanIdentifier_DataAreaObject,
  T_SummaryData,
} from "../features/Feature_Homeloan/Homeloan_Types";
import {
  T_MasterData_DetailObjOption,
  T_menu,
  T_Menu_List,
  T_Unified_Offer_Details,
} from "../features/Feature_GeneralAppElements/GeneralAppElements_Types";
import { T_TopBannerData } from "../features/Features_Cms/CmsGlobal.Types";
import {
  getIsChannelValid,
  getIsExactLobValid,
  normalizeStringToArray,
  usePlatformFlags,
} from "../hooks/utils/bannerFilterUtils";

// Extend Day.js with the necessary plugin
dayjs.extend(customParseFormat);

export const CurrencyFormat = (value: string = "") => {
  if (!value) return "";
  let tempValue = value.includes(".") ? parseFloat(value) : parseInt(value);
  if ([0, 0.0].includes(tempValue)) {
    return "";
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: tempValue.toString().includes(".") ? 2 : 0,
  }).format(tempValue);
};

export const CurrencyFormatText = (value: number = 0, withSymbol = true) => {
  let formatedValue = new Intl.NumberFormat("en-IN").format(value);
  if (withSymbol) {
    return "₹" + formatedValue;
  }
  return formatedValue;
};

export const currencyConvertor = (
  amountInNumber: any,
  fromMf?: boolean,
  toMaskValue?: boolean,
) => {
  if (fromMf && toMaskValue) {
    return "₹ --.--";
  }
  let lacs: any, crores: any, formattedAmount: any;
  const rupeeSymbol = fromMf ? "₹ " : "₹"; // Add space only if fromMf is true

  if (amountInNumber && !isNaN(amountInNumber)) {
    if (amountInNumber >= 10000000) {
      crores = (amountInNumber / 10000000).toFixed(2);
      formattedAmount =
        rupeeSymbol +
        (crores % 1 === 0 ? crores.split(".")[0] : crores) +
        " Crores";
    } else if (amountInNumber >= 100000) {
      lacs = (amountInNumber / 100000).toFixed(2);
      formattedAmount =
        rupeeSymbol + (lacs % 1 === 0 ? lacs.split(".")[0] : lacs) + " Lacs";
    } else {
      formattedAmount = CurrencyFormat(amountInNumber.toString());

      // Add rupee symbol + optional space according to fromMf if CurrencyFormat returns without space
      if (formattedAmount.startsWith("₹")) {
        formattedAmount = fromMf
          ? "₹ " + formattedAmount.slice(1)
          : "₹" + formattedAmount.slice(1);
      }
    }
  } else formattedAmount = amountInNumber;

  if (!formattedAmount) return "";
  return formattedAmount;
};

export const getPolicyStatus = (
  status: string | "",
  statusArray: T_MasterData_DetailObjOption[],
) => {
  let matchedStatus = statusArray.find((item) => item.masterKey === status);
  return isEmpty(matchedStatus) ? "" : matchedStatus.masterValue;
  // switch (status) {
  //   case "PREMIUM WAIVER OR PAYOR DEATH":
  //     return "Waiver";
  //   case "PAID-UP ANNUITY/EXTENDED TERM-ULIP":
  //   case "PAID-UP ANNUITY/EXTENDED TERM":
  //   case "RPU ULIP":
  //     return "Paid-Up";
  //   case "PREMIUM PAYING":
  //     return "In-Force";
  //   case "LAPSED":
  //     return "Lapsed";
  //   case "DISCONTINUED":
  //     return "Discontinued";
  //   case "TERMINATED":
  //     return "Terminated";
  //   case "SURRENDERED":
  //     return "Surrendered";
  //   case "WAIVER":
  //     return "Waiver";
  //   default:
  //     return "";
  // }
};

export const getStatusColor = (status: string | "") => {
  switch (status) {
    case "PREMIUM PAYING":
    case "PREMIUM WAIVER OR PAYOR DEATH":
    case "WAIVER":
      return Colors.cadmiumGreen;
    case "LAPSED":
    case "DISCONTINUED":
    case "PAID-UP ANNUITY/EXTENDED TERM-ULIP":
    case "PAID-UP ANNUITY/EXTENDED TERM":
    case "RPU ULIP":
      return Colors.iconYellow;
    case "SURRENDERED":
    case "TERMINATED":
      return Colors.red;
    default:
      return "";
  }
};

export const getPolicyType = (type: string | "") => {
  switch (type) {
    case "ULIP":
      return "Unit Linked Insurance Plan";
    case "PAR":
    case "NON-PAR":
    case "NON PAR":
      return "Savings Plan";
    case "ANNUITY":
      return "Retirement Plan";
    case "HEALTH":
      return "Critical Illness Plan";
    case "TERM":
      return "Term Plan";
    default:
      return "";
  }
};

export const getHiPolicyStatus = (status: string = "") => {
  let tempStatus = status.toLowerCase();
  if (tempStatus === "if") {
    return "Active";
  } else if (tempStatus === "expired") {
    return "Expired";
  } else if (tempStatus === "lapsed") {
    return "Lapsed";
  }
};

export const getHlPolicyStatus = (status: string = "") => {
  if (!status) {
    return "";
  }
  let tempStatus = status.toLowerCase();
  if (status === null || status === undefined) {
    return "";
  }
  if (tempStatus.toLowerCase() === "active") {
    return "Active";
  } else if (tempStatus.toLowerCase() === "closed") {
    return "Closed";
  } else {
    return "";
  }
};

export const getHiPolicyNameIcon = (
  name: string = "",
  pageName: string = "",
) => {
  switch (name.toLowerCase()) {
    case "platinum - essential":
      return pageName === "dashboard"
        ? activHealthPlatinumEssentialIcon
        : activHealthPlatinumEssentialIconRed;
    case "platinum - enhanced":
      return pageName === "dashboard"
        ? activHealthPlatinumEnhancedIcon
        : activHealthPlatinumEnhancedIconRed;
    case "preferred":
      return pageName === "dashboard"
        ? activFitPreferredIcon
        : activFitPreferredIconRed;
    case "plus":
      return pageName === "dashboard" ? activFitPlusIcon : activFitPlusIconRed;
    case "diamond":
      return pageName === "dashboard"
        ? activAssureDiamondIcon
        : activAssureDiamondIconRed;
    case "diamond plus":
      return pageName === "dashboard"
        ? activAssureDiamondPlusIcon
        : activAssureDiamondPlusIconRed;
    case "max":
      return pageName === "dashboard" ? activOneMaxIcon : activOneMaxIconRed;
    case "nxt":
      return pageName === "dashboard" ? activOneNxtIcon : activOneNxtIconRed;
    case "base plan (generic":
      return pageName === "dashboard"
        ? BasePlanGenericIcon
        : BasePlanGenericIconRed;
    case "top up plan (generic":
    case "plan a":
      return pageName === "dashboard"
        ? topUpPlanGenericIcon
        : topUpPlanGenericIconRed;
    case "plan b":
      return pageName === "dashboard"
        ? superTopUpPlanBIcon
        : superTopUpPlanBIconRed;
    default:
      return undefined;
  }
};

export const getHiMembersInsured = (
  insuredDetails: T_InsuredDetail[],
  FamilyDefinition: string,
) => {
  let policyType = FamilyDefinition?.toLowerCase();
  let displayString = "";
  if (["individual", "family floater"].includes(policyType)) {
    let isSelf =
      insuredDetails.filter((item) => item.vchRelation.toLowerCase() === "self")
        .length > 0;
    let isSpouse =
      insuredDetails.filter(
        (item) => item.vchRelation.toLowerCase() === "spouse",
      ).length > 0;
    let kidsCount = insuredDetails.filter(
      (item) => !["self", "spouse"].includes(item.vchRelation.toLowerCase()),
    ).length;
    if (isSelf) displayString += "Self";
    if (isSpouse) {
      if (displayString) displayString += ", ";
      displayString += "Spouse";
    }
    if (kidsCount > 0) {
      if (displayString) displayString += ", ";
      displayString += kidsCount === 1 ? "1 kid" : `${kidsCount} kids`;
    }
  } else if (policyType === "multi-individual") {
    const memberCount = insuredDetails.length;
    return `${memberCount} members`;
  }
  return displayString;
};

export const getOrdinalDateSuffix = (day: any) => {
  if (day > 3 && day < 21) return "th"; // exception for 11th, 12th, 13th
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatDateWithOrdinal = (dateStr: any) => {
  const date = dayjs(dateStr, "DD/MM/YYYY hh:mm:ss A");
  const day = date.date();
  const month = date.format("MMMM");
  const year = date.format("YYYY");
  const suffix = getOrdinalDateSuffix(day);

  return `${month} ${day}${suffix}, ${year}`;
};

export const todayDate = dayjs().format("DD-MM-YYYY");

export const filterValidOfferMartData = (
  unifiedOfferDetails: T_Unified_Offer_Details[],
  topBannersData: T_TopBannerData[],
  csAppSlice: T_CsAppSliceState,
  type: string,
) => {
  const userDetails = csAppSlice?.userDetails;
  const today = new Date();
  const fields = ["offer", "productCategory", "segment"]; // Fields to reset
  // Loop through validity checks and reset related fields
  if (isEmpty(unifiedOfferDetails)) {
    return [];
  }
  // unifiedOfferDetails.forEach((item: any) => {
  //   for (let i = 1; i <= 3; i++) {
  //     const validityKey = `validity${i}`;
  //     if (new Date(item?.[validityKey]) < today) {
  //       fields.forEach((field) => {
  //         item[`${field}${i}`] = null;
  //       });
  //     }
  //   }
  // });

  let unifiedOfferDetailsTemp = unifiedOfferDetails.map((item: any) => {
    let updatedItem = { ...item };

    for (let i = 1; i <= 3; i++) {
      const validityKey = `validity${i}`;
      if (new Date(item?.[validityKey]) < today) {
        fields.forEach((field) => {
          updatedItem = {
            ...updatedItem,
            [`${field}${i}`]: null,
          };
        });
      }
    }
    return updatedItem;
  });

  // Map segments from API1 to human-readable values
  const segmentMapping: Record<string, string> = {
    PA: "Pre-Approved",
    PQ: "Pre-Qualified",
    NBO: "Next Best Offer",
    PASA: "Pre-Approved Sum Assured",
    HP: "High Propensity",
  };
  // Extract filter conditions from API1 response
  const filterConditions = [
    {
      productName: unifiedOfferDetailsTemp[0]?.productCategory1,
      segment: segmentMapping[unifiedOfferDetailsTemp[0]?.segment1],
    },
    {
      productName: unifiedOfferDetailsTemp[0]?.productCategory2,
      segment: segmentMapping[unifiedOfferDetailsTemp[0]?.segment2],
    },
    {
      productName: unifiedOfferDetailsTemp[0]?.productCategory3,
      segment: segmentMapping[unifiedOfferDetailsTemp[0]?.segment3],
    },
  ];

  const channels: string[] = Array.from(
    new Set(
      userDetails?.customerAndLobDetails
        .map((item: any) => item?.CHANNEL?.toLowerCase())
        .filter(Boolean),
    ),
  );

  let lobCodes: string[] = Array.from(
    new Set(
      userDetails?.customerAndLobDetails
        .map((item: any) => item.LOB_CODE)
        .filter(Boolean),
    ),
  );
  if (isEmpty(lobCodes)) {
    lobCodes.push("NTB");
  }
  const isSuperApp = csAppSlice.channel === E_ChannelOptions.SUPER_APP; // true only when running on super app
  const isMobileApp = !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName); // true only for mobile App
  const isWeb = isSuperApp ? false : isMobileApp ? false : true; // true when runs on browser
  const isNtbUser = userDetails?.IS_NTB_USER;
  const isUserRegistered = userDetails?.IS_USER_REGISTERED;
  let userLobTag = "OTHERS";
  if (isNtbUser) userLobTag = "NTB";
  if (!isNtbUser && !isUserRegistered) userLobTag = "2FA-ND";
  // Filter logic
  let finalOfferMartCard = topBannersData?.filter((item: T_TopBannerData) => {
    const productName = item?.attributes?.productName;
    const segment = item?.attributes?.bannerCategory?.trim();
    const requiredPlatforms = normalizeStringToArray(
      item.attributes.platform?.toLowerCase(),
    );

    let matchesFilter;
    if (type === "staff_offer") {
      let isOfferDetailsObjPresent = unifiedOfferDetailsTemp.find((item) => {
        if (segment === "Staff_HLPA") {
          return item.tagging === "HFL";
        } else if (segment === "Staff_PLPA") {
          return item.tagging === "PL";
        }
        return false;
      });
      matchesFilter =
        (segment === "Staff_HLPA" || segment === "Staff_PLPA") &&
        isOfferDetailsObjPresent;
    } else {
      // Check if productName and segment match any filter condition
      matchesFilter = filterConditions.some(
        (condition) =>
          condition?.productName?.toLowerCase() ===
            productName?.toLowerCase() &&
          condition?.segment?.toLowerCase() === segment?.toLowerCase(),
      );
    }

    // Check if lobId includes any of the required values
    let isLobIdValid = getIsExactLobValid(
      item.attributes?.lobCohorts || "",
      lobCodes,
      userLobTag,
    );
    // Check if channel includes any of the required values
    const isChannelValid = getIsChannelValid(
      item.attributes?.channel || "",
      channels,
    );
    const isPlatformValid =
      (requiredPlatforms.includes(platformWeb) && isWeb) ||
      (requiredPlatforms.includes(platformMobile) && isMobileApp) ||
      (requiredPlatforms.includes(platformSuperApp) && isSuperApp);

    return matchesFilter && isChannelValid && isPlatformValid && isLobIdValid;
  });
  if (type === "unified_offer") {
    finalOfferMartCard = finalOfferMartCard?.map((item: any) => {
      const productName = item?.attributes?.productName;
      // Add `roi` and `amount` based on productName
      const updatedItem = { ...item }; // Create a shallow copy to avoid direct modification
      if (productName?.toLowerCase() === "personal loan") {
        updatedItem["roi"] = unifiedOfferDetailsTemp[0]?.plpaRoi;
        updatedItem["amount"] = unifiedOfferDetailsTemp[0]?.plpaOfferAmount;
        updatedItem["productName"] = productName;
      } else if (productName?.toLowerCase() === "business loan") {
        updatedItem["roi"] = unifiedOfferDetailsTemp[0]?.blpaRoi;
        updatedItem["amount"] = unifiedOfferDetailsTemp[0]?.blpaOfferAmount;
        updatedItem["productName"] = productName;
      } else if (productName?.toLowerCase() === "home loan") {
        updatedItem["amount"] = unifiedOfferDetailsTemp[0]?.hlPaOfferAmount;
        updatedItem["roi"] = unifiedOfferDetailsTemp[0]?.hlRoi;
        updatedItem["productName"] = productName;
      } else if (productName?.toLowerCase() === "life insurance") {
        updatedItem["productName"] = productName.toLowerCase();
        updatedItem["sumAssured"] =
          unifiedOfferDetailsTemp[0]?.termLiPasaValues &&
          unifiedOfferDetailsTemp[0]?.termLiPasaValues !== "0"
            ? unifiedOfferDetailsTemp[0]?.termLiPasaValues
            : unifiedOfferDetailsTemp[0]?.nontermLiPasaValues;
      }
      return updatedItem;
    });
    const segmentPriority: Record<string, number> = {
      "Pre-Approved": 1, // PA
      "Pre-Qualified": 2, // PQ
      "Next Best Offer": 3, // NBO
    };

    // Product priority inside PA
    const productPriority: Record<string, number> = {
      "Personal Loan": 1,
      "Life Insurance": 2,
      "Housing Finance": 3,
      "Health Insurance": 4,
    };

    finalOfferMartCard?.sort(offerMartSorter(segmentPriority, productPriority));
  } else if (type === "staff_offer") {
    finalOfferMartCard = finalOfferMartCard
      ?.filter(
        (item) =>
          item?.attributes?.bannerCategory?.trim() === "Staff_HLPA" ||
          item?.attributes?.bannerCategory?.trim() === "Staff_PLPA",
      )
      ?.map((item: any) => {
        const productName = item.attributes?.productName;
        // Add `roi` and `amount` based on productName
        const updatedItem = { ...item }; // Create a shallow copy to avoid direct modification
        if (productName === "Personal Loan") {
          let matchedObj = unifiedOfferDetailsTemp.find(
            (item) => item.tagging === "PL",
          );
          updatedItem["roi"] = matchedObj?.roi;
          updatedItem["amount"] = matchedObj?.plpaOfferAmountStaffOffers;
        } else if (productName === "Home Loan") {
          let matchedObj = unifiedOfferDetailsTemp.find(
            (item) => item.tagging === "HFL",
          );
          updatedItem["amount"] = matchedObj?.hlPaOfferAmount;
          updatedItem["roi"] = matchedObj?.roi;
        }
        updatedItem["productName"] = productName;
        return updatedItem;
      });
  }

  finalOfferMartCard = finalOfferMartCard?.map((item: any) => ({
    ...item,
    offerFor: type === "staff_offer" ? "staff" : "client",
  }));

  return finalOfferMartCard;
};

const offerMartSorter = (segmentPriority: any, productPriority: any) => {
  return (a: any, b: any) => {
    const segA = segmentPriority[a?.attributes?.segment] || 999;
    const segB = segmentPriority[b?.attributes?.segment] || 999;

    if (segA !== segB) return segA - segB;

    if (a?.attributes?.segment === "Pre-Approved") {
      const prodA = productPriority[a?.attributes?.productName] || 999;
      const prodB = productPriority[b?.attributes?.productName] || 999;
      return prodA - prodB;
    }

    return 0;
  };
};

//below 383-422 line are implemented to fix duplicates and files impacted are MF account, capitalgain,exitload
export const handleGTAEventsHelper = (
  type: string,
  screenName: string,
  field_placeholder_text?: string,
  field_placeholder_value?: string | null,
  isCapitalGain?: boolean,
) => {
  const commonParams = {
    screen_type: "mf_servicing",
    step_title: "my_statements",
    sub_step_title: "account_statements",
  };

  if (type === "formfield") {
    TriggerGTAEvent(
      isCapitalGain
        ? "mf_capital_gain_form_field"
        : "mf_serv_statement_form_field",
      {
        ...commonParams,
        screen_name: screenName,
        field_placeholder_text: field_placeholder_text,
        field_placeholder_value: field_placeholder_value,
      },
    );
  } else if (type === "Download") {
    TriggerGTAEvent(
      isCapitalGain
        ? "mf_capital_gain_download_cta_click"
        : "mf_serv_statement_form_submit",
      {
        ...commonParams,
        screen_name: screenName,
        CTA_text: type,
      },
    );
  }
};

// commonCleverTapEvent.ts
export const triggerFormFieldEvent = (
  title: string,
  value: string,
  mainCategory: string,
  subCategory: string,
) => {
  triggerCleverTapEvent(ACTIONS.mf_serv_statement_form_field, {
    ScreenType: SCREEN_TYPE.MFScreenType,
    isPrevPageNameRequired: true,
    FormFieldTitle: title,
    FormFieldValue: value,
    MainCategory: mainCategory,
    SubCategory: subCategory,
  });
};

//ABCD Holdings helper functions start
export const getRecentTransactionsIcon = (status?: string, type?: string) => {
  const statusValue = status?.toLowerCase();
  const isTransfer = type === transactionTypes.transfer;
  const isBuyRedeemSell =
    type === transactionTypes.buy ||
    type === transactionTypes.redeem ||
    type === transactionTypes.sell;

  switch (true) {
    // Case: Transfer completed or successful
    case isTransfer &&
      (statusValue === transactionApiStatus.successful ||
        statusValue === transactionApiStatus.transferred):
      return giftBoxIcon;

    // Case: Buy, Redeem, Sell successful, or Transfer reversed
    case (isBuyRedeemSell && statusValue === transactionApiStatus.successful) ||
      (isTransfer && statusValue === transactionApiStatus.reversed):
      return checkCircleIcon;

    // Case: Buy, Redeem, Sell or Transfer in progress
    case (isBuyRedeemSell && statusValue === transactionApiStatus.inProgress) ||
      (isTransfer && statusValue === transactionApiStatus.inProgress):
      return amberClockIcon;

    // Case: Buy, Redeem, Sell or Transfer failed
    case (isBuyRedeemSell && statusValue === transactionApiStatus.failure) ||
      (isTransfer && statusValue === transactionApiStatus.failure) ||
      statusValue === transactionApiStatus.failure:
      return alertCircleIcon;

    // Default case: return empty string
    default:
      return "";
  }
};

export const getMotorInsuranceProductIcon = (type?: string) => {
  if (type?.toLowerCase() === motorInsuranceProductTypes.car) {
    return carInsuranceIcon;
  } else {
    return bikeInsuranceIcon;
  }
};

export const getMotorInsurerProductLogo = (insurerName?: string) => {
  if (insurerName?.toLowerCase() === motorInsurerNames.iciciLombard) {
    return iciciLombardInsurerLogo;
  } else if (insurerName?.toLowerCase() === motorInsurerNames.acko) {
    return ackoInsurerLogo;
  } else {
    return digitInsurerLogo;
  }
};

export const dateDifferenceCalculator = (
  startDate: string,
  endDate: string,
) => {
  const start = dayjs(startDate); // Parse start date string
  const end = dayjs(endDate); // Parse end date string

  // Calculate the difference in days
  const diffInDays = end.diff(start, "day");

  // Convert days to years
  const diffInYears = Math.ceil(diffInDays / 365);

  if (diffInYears > 1) {
    return `${diffInYears} years`;
  } else {
    return `${diffInYears} year`;
  }
};

export const getRecentTransactionsText = (status: string) => {
  switch (status.toLowerCase()) {
    case transactionApiStatus.successful:
    case transactionApiStatus.transferred:
      return transactionStatus.success;
    case transactionApiStatus.inProgress:
      return transactionStatus.inProgress;
    case transactionApiStatus.failed:
    case transactionApiStatus.failure:
      return transactionStatus.failed;
    case transactionApiStatus.reversed:
      return transactionStatus.reversed;
    default:
      return "";
  }
};

export const getRecentTransactionsTextColor = (status: string) => {
  switch (status.toLowerCase()) {
    case transactionApiStatus.successful:
    case transactionApiStatus.reversed:
    case transactionApiStatus.transferred:
      return Colors.cadmiumGreen;
    case transactionApiStatus.inProgress:
      return Colors.amber;
    case transactionApiStatus.failed:
    case transactionApiStatus.failure:
      return Colors.red;
    default:
      return "";
  }
};

//ABCD Holdings helper functions end

export const formatAmount = (amount: string): string => {
  const number = parseFloat(amount);

  if (number % 1 === 0) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  }

  const formattedNumber = parseFloat(number.toFixed(2));
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(formattedNumber);
};

export { E_ChannelOptions };

export const getPolicyTermInYears = (days: number) => {
  if (typeof days !== "number" || days <= 0) {
    return "Invalid policy term";
  }
  const years = Math.round(days / 365);
  return `${years} year${years > 1 ? "s" : ""}`;
};

export const formatVehicleNumber = (value: string) => {
  const stateCode = value.substring(0, 2);
  const districtCode = value.substring(2, 4);
  const vehicleTypeCode = value.substring(4, 6);
  const vehicleNumberDigits = value.substring(6);
  return `${stateCode} ${districtCode} ${vehicleTypeCode} ${vehicleNumberDigits}`;
};

//utils function for OSP-2586 starts here

export const getActivePolicyByStatus = (
  policyDetailsData: T_FetchPolicyDetails_Response[],
): T_FetchPolicyDetails_Response => {
  let finalPolicyDetailsData: T_FetchPolicyDetails_Response;

  if (policyDetailsData.length === 1) {
    finalPolicyDetailsData = policyDetailsData[0];
  } else {
    let activePolicy = policyDetailsData.filter((policy) => {
      return !["TERMINATED", "SURRENDERED", "DISCONTINUED"].includes(
        policy.PolicyDetails?.POLICY_STATUS,
      );
    });
    if (!isEmpty(activePolicy)) {
      finalPolicyDetailsData = activePolicy[0];
    } else {
      finalPolicyDetailsData = policyDetailsData[0];
    }
  }

  return finalPolicyDetailsData;
};
//utils function for OSP-2586 ends here

//utils function for OSP-2567 starts here
export const filterDataByStatusAndDisbursement = (data: T_SummaryData[]) => {
  const allowedStatuses = ["A", "C"]; // Active, Closed
  const allowedDisbursalFlags = ["Y", "P"]; // Fully, Partially Disbursed

  return (
    data?.filter((item) => {
      const loanStatus = item.Loan_Status.rows[0]?.STATUS;
      const disbursalFlag = item.loan_info?.rows[0]?.FINAL_DISB_FLAG;
      return (
        allowedStatuses.includes(loanStatus) &&
        allowedDisbursalFlags.includes(disbursalFlag)
      );
    }) || []
  );
};
//utils function for OSP-2567 ends here

export const validateEmail = (email: string) => {
  if (email.length > 254) {
    return false;
  }
  const emailValidationRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  const consecutiveDotsRegex = /\.{2,}/;
  if (consecutiveDotsRegex.test(email) || !emailValidationRegex.test(email)) {
    return false;
  }
  const [localPart, domainPart] = email.split("@");
  if (!localPart || !domainPart) {
    return false;
  }
  if (
    localPart.startsWith(".") ||
    localPart.endsWith(".") ||
    domainPart.startsWith("-") ||
    domainPart.endsWith("-") ||
    domainPart.startsWith(".") ||
    domainPart.endsWith(".")
  ) {
    return false;
  }
  const domainSections = domainPart.split(".");
  if (domainSections.length < 2) {
    return false; // No valid TLD
  }
  return true;
};

//OSP-4439 utils start here
export const getFunctionalityCodesForLi = (data: T_Menu_List[] | undefined) => {
  const targetNames = [
    "Tax Certificate",
    "Premium Receipts",
    "Policy Account Statement",
    "Policy Bond",
  ];

  // Step 1: find "Services"
  const servicesMenu = data?.find((menu) => menu.menuName === "Services");

  // Step 2: inside Services, find "Download Statements"
  const downloadStatementsMenu = servicesMenu?.menuDetails?.find(
    (item) => item.menuName === "Download Statements",
  );

  // Step 3: filter its children by targetNames and map functionalityCodes
  const functionalityCodes = downloadStatementsMenu?.menuDetails
    ?.filter((item) => targetNames.includes(item.menuName))
    .map((item) => item.functionalityCode);

  return functionalityCodes ?? [];
};

export const fetchFunctionalityCodeByFeatureName = (
  data: T_Menu_List[] | undefined,
  featureName: string,
) => {
  const servicesMenu = data?.find((menu) => menu.menuName === "Services");

  const downloadStatementsMenu = servicesMenu?.menuDetails?.find(
    (item) => item.menuName === "Download Statements",
  );

  const functionalityCodes = downloadStatementsMenu?.menuDetails?.find(
    (item) => item?.menuName === featureName,
  )?.functionalityCode;

  return functionalityCodes ?? "";
};

//OSP-4439 utils end here

export const getFunctionalityCodesForHL = (data: T_menu[] | undefined) => {
  const targetNames = [
    "statement of account",
    "repayment schedule",
    "balance confirmation letter",
    "gst invoice",
    "list of documents",
    "insurance copy",
    "no dues certificate",
  ];

  // Step 1: find "Services"
  const servicesMenu = data?.find(
    (menu) => menu.menuName.toLowerCase() === "quick actions",
  );

  // Step 2: inside Services, find "Download Statements"
  const downloadStatementsMenu = servicesMenu?.menuDetails?.find(
    (item) => item.menuName.toLowerCase() === "statement & documents",
  );

  // Step 3: filter its children by targetNames and map functionalityCodes
  const functionalityCodes = downloadStatementsMenu?.menuDetails
    ?.filter((item) => targetNames.includes(item.menuName.toLowerCase()))
    .map((item) => item.functionalityCode);

  return functionalityCodes ?? [];
};

export const fetchHLFunctionalityCodeByFeatureName = (
  data: T_menu[] | undefined,
  featureName: string,
) => {
  const servicesMenu = data?.find(
    (menu) => menu?.menuName.toLowerCase() === "quick actions",
  );

  const downloadStatementsMenu = servicesMenu?.menuDetails?.find(
    (item) => item?.menuName.toLowerCase() === "statement & documents",
  );

  const functionalityCode = downloadStatementsMenu?.menuDetails?.find(
    (item) => item?.menuName.toLowerCase() === featureName.toLowerCase(),
  )?.functionalityCode;

  return functionalityCode ?? "";
};

export const formatStockCurrencyINR = (value?: string | number): string => {
  if (value === undefined || value === null || value === "") {
    return "0.00";
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return "0.00";
  }

  return numericValue.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const maskPAN = (pan: string, symbol: string = "X") => {
  if (!pan || pan.length !== 10) return pan;
  return `${pan.slice(0, 2)}${symbol.repeat(6)}${pan.slice(-2)}`;
};

//US-AB1-2026-0003 utils starts here
export const fetchLIMenuIconByFeatureName = (
  data: T_menu[] | undefined,
  featureName: string,
) => {
  let menuIcon = "";

  data?.forEach((mainMenu) => {
    mainMenu?.menuDetails?.forEach((subMenu) => {
      const matchedMenu = subMenu?.menuDetails?.find(
        (item) => item?.menuName?.toLowerCase() === featureName?.toLowerCase(),
      );

      if (matchedMenu) {
        menuIcon = matchedMenu?.menuIcon;
      }
    });
  });

  return menuIcon;
};
//US-AB1-2026-0003 utils ends here

//OSP-2887 utils starts here
export const fetchSelectedHomeLoanIdentifierData = (
  homeLoanIdentifierData: T_Fetch_HomeLoanIdentifier_DataAreaObject[],
  accountNumber: string,
) => {
  return homeLoanIdentifierData?.find(
    (item) => item?.LOANACCOUNTNO === accountNumber,
  );
};
//OSP-2887 utils end here

export const getChannelBySourceLobId = (sourceLobId: string) => {
  let channel = E_ChannelOptions.CSAPP;
  if (sourceLobId === Abcd_Super_App_Lob_Id) {
    channel = E_ChannelOptions.SUPER_APP;
  } else if (sourceLobId === OneLoginLobCode) {
    channel = E_ChannelOptions.ONE_ABC;
  } else if (sourceLobId === LiDestinationLobId) {
    channel = E_ChannelOptions.ABSLI;
  } else if (sourceLobId === HiDestinationLobId) {
    channel = E_ChannelOptions.ABHI;
  } else if (sourceLobId === MfDestinationLobId) {
    channel = E_ChannelOptions.ABSLAMC;
  } else if (sourceLobId === SsDestinationLobId) {
    channel = E_ChannelOptions.ABML;
  } else if (sourceLobId === HomeLoansDestinationLobId) {
    channel = E_ChannelOptions.ABHFL;
  } else if (sourceLobId === LoansDestinationLobId) {
    channel = E_ChannelOptions.ABFL;
  }
  return channel;
};

export const getOnboardingChannelId = (channel: E_ChannelOptions) => {
  if (channel === E_ChannelOptions.SUPER_APP) {
    return Abcd_Super_App_Lob_Id;
  } else if (channel === E_ChannelOptions.ONE_ABC) {
    return OneLoginLobCode;
  } else if (channel === E_ChannelOptions.ABSLI) {
    return LiDestinationLobId;
  } else if (channel === E_ChannelOptions.ABHI) {
    return HiDestinationLobId;
  } else if (channel === E_ChannelOptions.ABSLAMC) {
    return MfDestinationLobId;
  } else if (channel === E_ChannelOptions.ABML) {
    return SsDestinationLobId;
  } else if (channel === E_ChannelOptions.ABHFL) {
    return HomeLoansDestinationLobId;
  } else if (channel === E_ChannelOptions.ABFL) {
    return LoansDestinationLobId;
  }

  return "";
};
